import './index.scss';

import React from 'react';
import PropTypes from 'prop-types';

import CartIcon from '../../../assets/images/cart-white.svg';

import { getPriceDelimitedString } from '../../utils/services';

const CartSticky = props => {
  const { itemPrice, itemCount, onclick, offerData } = props;
  return (
    <>
      {offerData && (
        <div className="cart-sticky_offer" role="presentation">
          {offerData || ''}
        </div>
      )}
      <div
        className="cart-sticky"
        role="presentation"
        onClick={() => onclick()}
      >
        <div className="cart-sticky__price-wrapper">
          <div className="cart-sticky__price">
            <span>₹</span>
            {getPriceDelimitedString(Math.round(itemPrice))}
          </div>
          <div className="cart-sticky__divider" />
          <div>{itemCount} items</div>
        </div>
        <div className="cart-sticky__view-order">
          View Order
          <img className="cart-sticky__icon" src={CartIcon} alt="CartIcon" />
        </div>
      </div>
    </>
  );
};

CartSticky.propTypes = {
  itemPrice: PropTypes.string,
  itemCount: PropTypes.string
};

CartSticky.defaultProps = {
  itemPrice: '',
  itemCount: ''
};

export default CartSticky;
